import { render, staticRenderFns } from "./ProcessesView.vue?vue&type=template&id=7cd1c060&scoped=true&"
import script from "./ProcessesView.vue?vue&type=script&lang=js&"
export * from "./ProcessesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1c060",
  null
  
)

export default component.exports